import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 40px 20px;
  overflow-y: auto;
  background: #f9fafb;
  z-index: 1000;
`

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
  text-align: center;
`

export const Description = styled.p`
  font-size: 1.1rem;
  color: #666;
  text-align: center;
  margin-bottom: 48px;
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 32px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`

export const DocCard = styled.div`
  background: #fff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 32px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-4px);
    border-color: #0090d3;
    box-shadow: 0 8px 16px rgba(0, 144, 211, 0.15);
  }
`

export const CardIcon = styled.div`
  color: #0090d3;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 12px;
`

export const CardDescription = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  line-height: 1.5;
`

export const CloseButton = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1001;

  &:hover {
    background: #ef4444;
    border-color: #ef4444;
    color: #fff;
  }
`
